/** Entornos de ejecucion soportados. Determinan que archivos `.env.<entorno>` se cargan. */
export const APP_ENVIRONMENTS = ['development', 'test', 'production'] as const;
export type AppEnvironment = (typeof APP_ENVIRONMENTS)[number];

/** Formas de instalacion de la plataforma. */
export const DEPLOYMENT_MODES = ['desktop', 'server', 'docker'] as const;
export type DeploymentMode = (typeof DEPLOYMENT_MODES)[number];

export const LOG_LEVELS = ['fatal', 'error', 'warn', 'info', 'debug', 'trace'] as const;
export type LogLevel = (typeof LOG_LEVELS)[number];

export const isAppEnvironment = (value: unknown): value is AppEnvironment =>
  typeof value === 'string' && (APP_ENVIRONMENTS as readonly string[]).includes(value);
